"use client";

import React from "react";

import Button from "./Button";
import useAppContext from "../hooks/useAppContext";

export const VIEW_PARAM = "viewAs";

const ViewToggle = () => {
  const { preferredListViewStyle, changeListViewStyle } = useAppContext();

  return (
    <div className="d-flex align-items-end justify-content-between">
      <div className="list-view-toggle d-flex align-items-center justify-content-between gap-1 border-radius-xs">
        <Button
          className="list-view-toggle__button"
          appearance="quaternary"
          icon="grid-view"
          aria-selected={preferredListViewStyle === "grid"}
          onClick={() => {
            changeListViewStyle("grid");
          }}
        />
        <Button
          className="list-view-toggle__button"
          appearance="quaternary"
          icon="splitscreen"
          aria-selected={preferredListViewStyle === "list"}
          onClick={() => changeListViewStyle("list")}
        />
      </div>
    </div>
  );
};

export default ViewToggle;
